import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: '',
    distributionDates: [],
    typeValues: [],
    distributions: []
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
